import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { cn } from '@/lib/utils'

const MentionList = forwardRef(({ items, command }, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  useEffect(() => setSelectedIndex(0), [items])

  const selectItem = (index) => {
    const item = items[index]
    if (item) command(item)
  }

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        setSelectedIndex((selectedIndex + items.length - 1) % items.length)
        return true
      }
      if (event.key === 'ArrowDown') {
        setSelectedIndex((selectedIndex + 1) % items.length)
        return true
      }
      if (event.key === 'Enter') {
        selectItem(selectedIndex)
        return true
      }
      return false
    },
  }))

  if (!items.length) {
    return (
      <div className="bg-popover border rounded-lg shadow-md p-2 text-sm text-muted-foreground">
        No results
      </div>
    )
  }

  return (
    <div className="bg-popover border rounded-lg shadow-md py-1 max-h-60 overflow-y-auto min-w-[200px]">
      {items.map((item, index) => (
        <button
          key={item.id}
          type="button"
          className={cn(
            'flex items-center gap-2 w-full px-3 py-1.5 text-sm text-left transition-colors',
            index === selectedIndex ? 'bg-accent text-accent-foreground' : 'hover:bg-accent/50'
          )}
          onClick={() => selectItem(index)}
        >
          <span className="w-6 h-6 rounded-full bg-primary/10 text-primary text-[10px] font-medium flex items-center justify-center shrink-0">
            {item.label?.charAt(0)?.toUpperCase() || '?'}
          </span>
          <span className="truncate">{item.label}</span>
        </button>
      ))}
    </div>
  )
})

MentionList.displayName = 'MentionList'

export default MentionList
